<template>
  <div>
    <!-- 替换链接编辑弹窗 -->
    <el-dialog :title="$t('message.replaceLinkEdit')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1200px" center>
      <!-- 内容区域 -->
      <div class="dialog-content">
        <div class="table">
          <ol>
            <!-- 商品链接 -->
            <li>
              {{ $t('message.ProductLink') }}
            </li>
            <!-- 店铺信息 -->
            <li class="flex05">
              {{ $t('message.storeInformation') }}
            </li>
            <!-- 照片 -->
            <li class="flex05">
              {{ $t('message.pic') }}
            </li>
            <!-- 客户下单属性 -->
            <li>
              {{ $t('message.customerOrderAttributes') }}
            </li>
            <!-- 业务编辑属性 -->
            <li>
              {{ $t('message.businessEditAttributes') }}
            </li>
          </ol>
          <ul>
            <!-- 商品链接 -->
            <li>
              <el-input type="textarea" v-model="form.link" placeholder="请输入商品链接" @blur="goodsParticulars" />
            </li>
            <!-- 店铺信息 -->
            <li class="flex05">
              <div class="template">
                <!-- 店铺名 -->
                <div class="row">
                  {{ form.shop_name }}
                </div>
                <!-- 平台 -->
                <div class="row">
                  {{ form.from_platform }}
                </div>
                <!-- 店铺ID -->
                <div class="row">
                  {{ form.shop_id }}
                </div>
              </div>
            </li>
            <!-- 照片 -->
            <li class="flex05">
              <div class="template">
                <!-- 照片 -->
                <div class="img" v-if="form.pic">
                  <el-image :src="form.pic" fit="fill" style="width: 100px; height: 100px;border-radius: 4px;"
                    :preview-src-list="[form.pic]" />
                  <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'"
                    :show-file-list="false" :http-request="httpup" :before-upload="beforeAvatarUpload">
                    <i class="el-icon-edit-outline"></i>
                  </el-upload>

                </div>
              </div>

            </li>
            <!-- 客户下单属性 -->
            <li>
              <div class="template" @click="editAttribute">
                <!-- 客户下单属性 -->
                <div class="row" v-for="(item, index) in form.detail" :key="index">
                  {{ item.key }}: {{ item.value }}
                </div>
              </div>
            </li>
            <!-- 业务编辑属性 -->
            <li>
              <div class="template" @click="editAttribute">
                <!-- 业务编辑属性 -->
                <div class="row" v-for="(item, index) in form.detail_y" :key="index">
                  {{ item.key }}: {{ item.value }}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- 操作按钮区域 -->
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" @click="submitForm">
          {{ $t('message.save') }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 修改属性 -->
    <el-dialog :title="$t('message.propertyEditForm')" :close-on-click-modal="false"
      :visible.sync="attributeDialogVisible" width="1400px" center>

      <div class="content">
        <!-- 商品属性 -->
        <div class="item">
          <div class="title">{{ $t("message.commodityAttribute") }}</div>
          <editAttribute ref="detailRef" />
        </div>
        <!-- 业务商品属性 -->
        <div class="item">
          <div class="title">{{ $t("message.businessEditAttributes") }}</div>
          <editAttribute ref="detail_yRef" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="attributeDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="saveAttribute">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import editAttribute from "@/components/common/editAttribute.vue";
export default {
  components: { editAttribute, },
  data() {
    return {
      dialogVisible: false,
      attributeDialogVisible: false,
      form: {
        link: '',
        problem_goods_id: '',
        from_platform: '',
        goods_id: '',
        mi_id: '',
        pic: '',
        shop_id: '',
        shop_name: '',
        detail: [],
        sku_id: '',
        spec_id: '',
        detail_y: [],
        sku_id_y: '',
        spec_id_y: '',

      },
      goodsInventory: {},//商品库存信息
      detail: {}, //商品详情
    };
  },
  methods: {
    // 提交表单
    submitForm() {
      this.$api.problemApi.saveReplaceGoods(this.form).then(res => {
        if (res.code == 0) {
          this.$message({
            message: res.msg,
            type: 'success',
          })
          this.dialogVisible = false
          this.$emit('refresh', this.form)
        }
      })

    },
    // 商品详情
    goodsParticulars() {
      if (this.form.link == '') {
        this.$message({
          message: '请输入商品链接',
          type: 'warning',
        })
        return
      }

      this.$api.goodsUrlToGoodsId({ goods_url: this.form.link }).then(res => {
        const miId = res.data.mi_id || ''
        let timestamp = Math.floor(new Date().valueOf() / 1000)
        let sign = 'wakanda forever!@9523`'
        let datas = {
          shop_type: res.data.from_platform,
          goods_id: res.data.goods_id,
          mi_id: miId,
          timestamp,
          sign: this.$md5(`${sign}${timestamp}${sign}`)
        };
        this.$api.orderApi.goodsParticulars(datas).then((res) => {

          let data = res.data;
          this.detail = res //
          this.goodsInventory = res.data.goodsInfo.goodsInventory;
          let detail_y = []
          res.data.goodsInfo.specification.forEach(item => {
            detail_y.push({
              key: item.keyC,
              value: item.valueC[0].name,
            })
          })

          this.form.goods_id = data.goodsId;
          this.form.mi_id = data.mi_id || data.miId || miId;
          this.form.goods_title = data.titleC;
          this.form.shop_id = data.shopId;
          this.form.shop_name = data.shopName;
          this.form.from_platform = data.fromPlatform;
          this.form.pic = data.images[0];
          this.form.detail = detail_y;
          this.form.detail_y = detail_y;
          // this.form.goodsInventory = data.goodsInfo.goodsInventory
          // this.receiveAttributeEdit(detail_y, '')
          this.editAttribute()
          this.$forceUpdate();

        });
      })
    },
    // 编辑属性
    editAttribute() {
      let detail = {
        detail: this.form.detail,
        sorting: 1,
        from_platform: this.form.from_platform,
        type: 'detail'
      }
      let detail_y = {
        detail: this.form.detail_y,
        sorting: 1,
        from_platform: this.form.from_platform,
        type: 'detail_y'
      }
      this.attributeDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.detailRef.goodsParticulars(JSON.parse(JSON.stringify(this.detail)), detail)
        this.$refs.detail_yRef.goodsParticulars(JSON.parse(JSON.stringify(this.detail)), detail_y)
      })
    },
    // 保存属性
    saveAttribute() {
      this.$refs.detailRef.save()
      this.$refs.detail_yRef.save()
    },
    // 接收修改属性
    receiveAttributeEdit(data, pic, type) {
      if (type == 'detail') {
        this.form.detail = data;
      } else {
        this.form.detail_y = data;
      }
      if (pic) {
        this.form.pic = pic;
      }
      this.searchPricr(data, type);
      this.attributeDialogVisible = false;
    },
    // 查找价格
    searchPricr(data, type) {
      let str = "";
      data.forEach((item) => {
        str += item.value + "㊖㊎";
      });
      str = str.substr(0, str.length - 2);
      for (let i = 0; i < this.goodsInventory.length; i++) {
        if (this.goodsInventory[i].keyC == str) {

          this.form.price = this.goodsInventory[i].valueC[0].price;
          if (type == 'detail') {
            this.form.sku_id =
              this.goodsInventory[i].valueC[0].skuId;
            this.form.spec_id =
              this.goodsInventory[i].valueC[0].specId;
          } else if (type == 'detail_y') {
            this.form.sku_id_y =
              this.goodsInventory[i].valueC[0].skuId;
            this.form.spec_id_y =
              this.goodsInventory[i].valueC[0].specId;
          } else {
            this.form.sku_id =
              this.goodsInventory[i].valueC[0].skuId;
            this.form.spec_id =
              this.goodsInventory[i].valueC[0].specId;
            this.form.sku_id_y =
              this.goodsInventory[i].valueC[0].skuId;
            this.form.spec_id_y =
              this.goodsInventory[i].valueC[0].specId;
          }
          // this.form.num =
          //   this.goodsInventory[i].valueC[0].startQuantity;
          break;
        } else {
          this.form.price = "";
          if (type == 'detail') {
            this.form.sku_id = "";
            this.form.spec_id = "";
          } else if (type == 'detail_y') {
            this.form.sku_id_y = "";
            this.form.spec_id_y = "";
          }
        }
      }
      this.$forceUpdate();
    },
    // 图片上传事件
    async httpup(file) {
      let data = await this.createClient(file)
      this.form.pic = data.data
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";
      this.loading = true;
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
        this.loading = false;
      }
      return isJPG || isPNG || isSVG;
    },
  },
};
</script>
<style scoped lang="scss">
.dialog-content {
  .table {
    li {
      margin-right: 12px;
      cursor: pointer;

      &:nth-last-child(1) {
        margin: 0;
      }
    }

    .flex05 {
      flex: 0.5;
    }

    .img {
      position: relative;

      .el-icon-edit-outline {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 16px;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.5);
        padding: 2px 4px;
        border-radius: 4px;
      }
    }
  }
}

.content {
  display: flex;

  .item {
    flex: 1;

    &:nth-last-child(1) {
      margin-left: 50px;
    }
  }
}
</style>
